<template>
    <v-dialog v-model="show" width="300">
        <v-card class="pa-5">
            <v-layout justify-center mb-5>
                <v-flex shrink>
                    {{message}}
                </v-flex>
            </v-layout>
            <div class="d-flex justify-center">
                <GreenButton label="OK" @onPress="eventClick"></GreenButton>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import GreenButton from "../buttons/GreenButton";
    export default {
        components: {
            GreenButton
        },
        props: ["show", "message"],
        methods: {
            eventClick() {
                this.$emit('onConfirm');
            }
        }
    }
</script>

<style scoped>

</style>
